import { Link } from "react-router-dom";
import type { ComicArticle } from "@/mocks/comics";

interface FeaturedComicsProps {
  comics: ComicArticle[];
}

export default function FeaturedComics({ comics }: FeaturedComicsProps) {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-display text-foreground-950">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            本周最受欢迎的韩漫精选
          </p>
        </div>
        <Link
          to="/category/lianai"
          className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
        {comics.map((comic) => (
          <Link
            key={comic.id}
            to={`/article/${comic.id}`}
            className="group cursor-pointer"
            data-product-shop=""
          >
            <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-2.5">
              <img
                src={comic.coverImage}
                alt={comic.title}
                title={`${comic.title} - 免费韩漫在线阅读`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-2 left-2">
                <span className="px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                  {comic.rating}
                </span>
              </div>
              {comic.isHot && (
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
                    HOT
                  </span>
                </div>
              )}
            </div>
            <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
              {comic.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-0.5">
              {comic.author} · {comic.category}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}